import gsap from "@lib/gsap";
import {
  headingAnimation,
  lineAnimation,
  paragraphAnimation,
  cornerBlockAnimation,
  videoAnimation,
} from "@lib/animations";
import { onMount, onDestroy, onPageIn } from "./_";
import { Resize } from "@lib/subs";

export default function (element) {
  let tl, heading, paragraph;
  let played = false;

  onMount(() => {
    heading = headingAnimation(element, "h1");
    paragraph = paragraphAnimation(element, "p");

    tl = gsap.timeline({ paused: true });
    tl.add(heading.tl);
    tl.add(lineAnimation(element, "down"), "<+=0.4");
    tl.add(paragraph.tl, "<+=0.2");
    tl.add(videoAnimation(element), "<+=0.2");
    tl.add(cornerBlockAnimation(element), "<+=0.2");
  });

  onPageIn(() => {
    tl.play();
    played = true;
  });

  const removeResize = Resize.add(() => {
    if (!played) return;
    heading.revert();
    paragraph.revert();
    heading = headingAnimation(element, "h1");
    paragraph = paragraphAnimation(element, "p");
  });

  onDestroy(() => {
    removeResize();
    heading?.revert();
    paragraph?.revert();
    tl?.kill();
  });
}
